// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__Mv-Rx","label":"CategoryService_label__3ODnq","location":"CategoryService_location__3-6HV"};